import React, { useState } from 'react';
import { useSearchResults, useSearchQuestion } from '@context/DataContext';
import { getValue } from '@hooks/useLocalStorage';
const SearchTabSaved = () => {
  const { contentHeadings, resultTab, localStorageKey, tabNames } = useSearchResults();
  const { setTab } = useSearchQuestion();
  const [count, setCount] = useState(getValue(localStorageKey)?.length, 0);
  // get items from local storage
  let items = getValue(localStorageKey);
  // on click check if we have any favorites, and switch tabs
  const handleClick = () => {
    setTab(tabNames.saved);
  };
  // listen for storage changes and update the count badge value
  window.addEventListener('storage', () => {
    items = getValue(localStorageKey);
    if (typeof items !== 'undefined') setCount(items.length);
  });
  const active = resultTab === tabNames.saved ? 'base-search-tabs-control__link--active' : '';
  return (
    <li className={`base-search-tabs-control__item ${!count ? 'base-search-tabs-control__item--disabled' : ''}`} role="presentation">
      <button className={`base-search-tabs-control__link ${active}`} onClick={handleClick} role="tab" aria-selected={resultTab === tabNames.saved}>
        {contentHeadings?.tabSaved || 'Favorites'}
        {count > 0 && <span className="base-search-tabs__control-badge">{count}</span>}
      </button>
    </li>
  );
};
export default SearchTabSaved;
